/**
 * What a Website V2 publish adds to legacy's `PublishGoLive` extraInfo, so publish reporting can tell
 * the editors apart. Legacy passes no site, gets `{}`, and its payload is left untouched.
 */
export const getWebsiteV2PublishExtraInfo = (websiteV2SiteId: string | null): Readonly<{ editorVersion: 'v2'; siteId: string }> | Readonly<Record<string, never>> =>
  websiteV2SiteId ? { editorVersion: 'v2', siteId: websiteV2SiteId } : {};
